module.exports = __webpack_public_path__ + "static/media/sound.097c10e0.mp3";